// extracted by mini-css-extract-plugin
export default {"form":"CreateColumnForm_form__Yc+Dd","fields":"CreateColumnForm_fields__5TKwN"};